import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import DemandeDevis from './pages/DemandeDevis';
import ThankYou from './pages/ThankYou';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demande-devis" element={<DemandeDevis />} />
        <Route path="/merci" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;